'use client'
import React from 'react'

export interface IconButtonProps {
  children: React.ReactNode
  onClick?: () => void
  className?: string
  disabled?: boolean
  'data-testid'?: string
  'aria-label'?: string
}

export const IconButton: React.FC<IconButtonProps> = ({
  children,
  onClick,
  className = '',
  disabled = false,
  'data-testid': testId,
  'aria-label': ariaLabel,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`
        inline-flex items-center justify-center
        w-10 h-10 rounded-sm p-1 [border:2px]
        text-gray-800 hover:bg-gray-100
        disabled:opacity-50 disabled:cursor-not-allowed
        transition-colors duration-200
        ${className}
      `.trim()}
      data-testid={testId}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  )
}
